import React, { useState, useEffect } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [clientUrl, setClientUrl] = useState(null);

  // Load client_url on component mount
  useEffect(() => {
    // First check URL params (in case it's a fresh widget load)
    const searchParams = new URLSearchParams(window.location.search);
    const urlClientUrl = searchParams.get('client_url');
    
    if (urlClientUrl) {
      // Store it in sessionStorage (cleared when browser closes)
      sessionStorage.setItem('client_url', urlClientUrl);
      setClientUrl(urlClientUrl);
      console.log('✅ Stored client_url in sessionStorage:', urlClientUrl);
    } else {
      // Otherwise, get from sessionStorage
      const storedUrl = sessionStorage.getItem('client_url');
      setClientUrl(storedUrl);
    }
  }, []);

  const handleHomeClick = () => {
    if (clientUrl) {
      // Redirect to the client's URL
      window.location.href = clientUrl;
    } else {
      // Do nothing - keep the user on the current page
      console.log('No client_url found, staying on current page');
      // Optionally, you could show a message or disable the button
    }
  };

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <header className="w-full top-0 left-0 z-20 bg-white h-auto border-b border-gray-200">
      <div className="container mx-auto px-6 lg:px-8 py-2 h-full flex justify-between items-center">
        <button 
          onClick={handleBackClick} 
          className="flex items-center"
        >
          <img 
  src="https://www.welcomheritagehotels.in/images/wh-logo.png" 
  alt="WelcomHeritage Hotels" 
  className="h-14 md:h-20 w-auto object-contain"
/>
        </button>
        
        <button 
          onClick={handleHomeClick}
          disabled={!clientUrl}
          className={`px-4 py-2 text-base font-medium rounded-md transition-colors duration-200 ${
            clientUrl 
              ? 'text-text-secondary hover:bg-gray-100 hover:text-brand-accent cursor-pointer' 
              : 'text-gray-400 cursor-not-allowed'
          }`}
          title={clientUrl ? "Go to hotel website" : "No hotel website available"}
        >
          Home
        </button>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white shadow-lg lg:hidden z-10 border-t border-gray-200">
          <nav className="flex flex-col p-4 space-y-2">
            <button 
              onClick={handleHomeClick}
              disabled={!clientUrl}
              className={`block px-4 py-2 text-base font-medium rounded-md transition-colors duration-200 text-left w-full ${
                clientUrl 
                  ? 'text-text-secondary hover:bg-gray-100 hover:text-brand-accent' 
                  : 'text-gray-400 cursor-not-allowed'
              }`}
              title={clientUrl ? "Go to hotel website" : "No hotel website available"}
            >
              Home
            </button>
            <a href="#" className="block px-4 py-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200">Help</a>
            <a href="#" className="block px-4 py-2 mt-2 text-base font-medium text-text-secondary hover:bg-gray-100 hover:text-brand-accent rounded-md transition-colors duration-200 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              My Account
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;